import { useMutation } from '@gogame/query';
import { useScreenMessage } from '@gogame/screens';

import { exportCohorts } from 'scenes/Trackers/Tracker/sources/metrics';

import { exportCohorts as exportCohortsKey } from '../queryKeyFactory';

export const useExportCohorts = () => {
  const { showMessage } = useScreenMessage();

  const exportMutation = useMutation(exportCohortsKey(), exportCohorts, {
    successMessage: () => 'Cohorts download completed',
    refresh: false,
  });
  const handleAction = params => {
    showMessage('Download has started');
    exportMutation.mutateAsync(params);
  };

  return [handleAction, exportMutation];
};
